/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import { $window, classSet } from '@umu/umu-dom';
import * as ImageUtil from '@umu/umu-image-handle';
import type { IUserMedal } from '@umu/umu-types';
import { If, PreImg } from 'common/src/components';
import React, { Component } from 'react';

import UserLevelBadge, { type TUserLevelSize } from '../userLevelBadge/userLevelBadge';
import UserMedalIcon from '../userMedalIcon/userMedalIcon';
import './userAvatar.scss';

export interface IProps {
  id?: string;
  className: string;
  src: string;
  width?: number;
  index?: number;
  userLevelInfo?: number;
  userMedalInfo?: IUserMedal;
  showUserLevel?: number;
  userMedalWidth?: 20 | 30 | 16 | 12;
  userLevelSize?: TUserLevelSize;
  href?: string;
  jumpWidthSelf?: boolean;
  isOriginal?: boolean; // 原图展示
  isToProfile?: boolean;
  isStudentId?: boolean;
  isLogin?: boolean;
  onClick?: () => void;
  isTransformPx2Rem?: boolean;
}

interface IState {
  loadFail: boolean;
}
import { getDefaultAvatar } from 'businessCommon/src/@utils';
import { isFromCourseMiniApp } from '../../../@utils';
import defaultAvatar from '../../../images/default-avatar-radiu.png';
import { goUserProfile } from '../../../services';

const defaultAvatarUrl = getDefaultAvatar() || defaultAvatar;
const isInUSE = (window as any).isInUSE || window.location.pathname.startsWith('/use');

export default class UserAvatar extends Component<IProps, IState> {
  constructor(props: IProps, state: IState) {
    super(props, state);

    this.loadError = this.loadError.bind(this);

    this.state = {
      loadFail: false,
    };
  }

  public loadError() {
    this.setState({
      loadFail: true,
    });
  }

  public renderAvatarImage() {
    const { src, width = 40, isTransformPx2Rem = true, isOriginal = false } = this.props;
    const style = {
      width: isTransformPx2Rem ? `${width / 100}rem` : `${width}px`,
      height: isTransformPx2Rem ? `${width / 100}rem` : `${width}px`,
    };

    const imgSrc =
      !this.state.loadFail && src ? (isOriginal ? src : ImageUtil.appendWidth(src, width * 2)) : defaultAvatarUrl;
    return (
      <div className='user-avatar-image img' style={style}>
        <PreImg>
          <img src={imgSrc} onError={this.loadError} className='circle-img' />
        </PreImg>
      </div>
    );
  }

  public redirectToProfileHome = (href = '') => {
    const { id, isToProfile, isStudentId = true, onClick } = this.props;

    if (onClick) {
      onClick();
    }

    if (isToProfile && id) {
      goUserProfile(id, isStudentId);
      return;
    }

    if (!href) {
      return;
    }

    if (isFromCourseMiniApp()) {
      return;
    }

    const jumpWidthSelf = this.props.jumpWidthSelf;
    $window.open(href, jumpWidthSelf ? '_self' : '_blank');
  };

  public render() {
    const {
      className,
      isToProfile,
      userMedalInfo,
      showUserLevel = 0,
      userLevelInfo = 0,
      userMedalWidth = 20,
      userLevelSize,
      href = '',
      isTransformPx2Rem,
      isLogin = true,
    } = this.props;

    const actualShowUserLevel = isInUSE ? 0 : showUserLevel;
    const userLevelHolderSize = userLevelSize ? ` size-${userLevelSize}` : '';
    const cursor = (!!href || isToProfile) && isLogin ? 'cursor' : '';

    return (
      <div className={classSet('user-avatar-info', className, cursor)} onClick={() => this.redirectToProfileHome(href)}>
        {this.renderAvatarImage()}
        <If condition={!!actualShowUserLevel && userLevelInfo !== 0}>
          <div className={`user-level-info-holder${userLevelHolderSize}`}>
            <UserLevelBadge isTransformPx2Rem={false} userLevelInfo={+userLevelInfo} userLevelSize={userLevelSize} />
          </div>
        </If>
        <If condition={!!actualShowUserLevel && !!userMedalInfo && !!userMedalInfo.medal_type}>
          <div className='user-medal-info-holder'>
            <UserMedalIcon
              isTransformPx2Rem={isTransformPx2Rem}
              userMedalInfo={userMedalInfo!}
              userMedalWidth={userMedalWidth}
            />
          </div>
        </If>
      </div>
    );
  }
}
